import React from 'react';
import { BrowserRouter as Router, Route, Routes, useParams, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';  // Import your new ScrollToTop component
import HomePage from './components/HomePage';
import GlobalStyle from './GlobalStyle';
import CaseStudyHome from './components/CaseStudyHome';
import CubanBikeMarket from './components/CubanBikeMarket';
import PopulationPreferences from './components/PopulationPreferences';
import TaskDescription from './components/TaskDescription';
import SideNav from './components/SideNav';
import SegmentPreferenceIndex from './components/SegmentPreferenceIndex';
import SegmentInformation from './components/SegmentInformation';
import DecisionTool from './components/DecisionTool';
import FAQ from './components/FAQ';
import VentraChatbot from './components/VentraChatbot';
import { LayoutWrapper } from './styles/Layout.styles';
import DecisionTool2 from './components/DecisionTool2';
import Feedback from './components/Feedback';
import DecisionTool3 from './components/DecisionTool3';
import ProtectedRoute from './components/ProtectedRoute';
import ProfessorDashboard from './components/Professor/ProfessorDashboard';
import SimulationDetail from './components/Professor/SimulationDetail';
import ScoresPage from './components/Professor/ScoresPage';
import ProfessorLogin from './components/Professor/ProfessorLogin';
import ProfessorSignup from './components/Professor/ProfessorSignup';
import AccountMenu from './components/Professor/AccountMenu';
import AccessExpired from './components/Professor/AccessExpired';
import StudentDashboard from './components/StudentDashboard';
import StudentResults from './components/StudentResults';
import { useLocation } from 'react-router-dom';


const AppLayout = () => {
  const { teamId } = useParams();

  return (
    <div className="app-layout"
      style={{
        display: 'flex',
      }}
    >
      {teamId && <SideNav teamId={teamId} />}
      <div className="main-content" style={{ flexGrow: 1, paddingLeft: '24px', paddingTop: '4px', paddingRight: '24px' }}>
        <Routes>
          <Route path="home" element={<CaseStudyHome teamId={teamId} />} />
          <Route path="task-description" element={<TaskDescription teamId={teamId} />} />
          <Route path="population-preferences" element={<PopulationPreferences />} />
          <Route path="cuban-bike-market" element={<CubanBikeMarket />} />
          <Route path="segment-preference-index" element={<SegmentPreferenceIndex />} />
          <Route path="segment-information-by-tier" element={<SegmentInformation />} />
          <Route path="decision-tool" element={<DecisionTool />} />
          <Route path="decision-tool-2" element={<DecisionTool2 teamId={teamId} />} />
          <Route path="decision-tool-3" element={<DecisionTool3 teamId={teamId} />} />
          <Route path="results" element={<StudentResults teamId={teamId} />} />
          <Route path="ventra" element={<VentraChatbot />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="feedback" element={<Feedback teamId={teamId} />} />
        </Routes>
      </div>
    </div>
  );
};

const App = () => {
  const location = useLocation(); // now inside the Router context

  const showAccountMenu = location.pathname !== '/' && location.pathname !== '/professor-login' && location.pathname !== '/professor-signup' && location.pathname !== '/access-expired';

  return (
    <LayoutWrapper>
      {showAccountMenu && (
        <div
          style={{
            position: 'fixed',
            top: '10px',
            right: '20px',
            zIndex: 1000,
          }}
        >
          <AccountMenu />
        </div>
      )}

      {/* Main routing */}
      <ScrollToTop />
      <GlobalStyle />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/student-dashboard" element={<StudentDashboard />} />
        <Route path="/:teamId/*" element={<AppLayout />} />
        <Route path="/professor-login" element={<ProfessorLogin />} />
        <Route path="/professor-signup" element={<ProfessorSignup />} />
        <Route path="/access-expired" element={<AccessExpired />} />
        <Route path="/professor-dashboard" element={<ProtectedRoute><ProfessorDashboard /></ProtectedRoute>} />
        <Route path="/simulation/:gameId" element={<ProtectedRoute><SimulationDetail /></ProtectedRoute>} />
        <Route path="/simulation/:gameId/scores/:roundNumber" element={<ProtectedRoute><ScoresPage /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </LayoutWrapper>
  );
};

// TODO: Look into this warning
export default () => (
  <Router>
    <App />
  </Router>
);


